module.exports = __webpack_public_path__ + "media/images/lb/405-6f25eb14ca15206df649c6e5aeb85269.svg";